document.addEventListener("scroll", (event) => {
  let header = document.querySelector('.yas_header');
  if (!header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop > 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }
  if (header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop <= 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }
});

(function () {
  var confirmedHeaderCartCount = null;
  var heldHeaderCartCount = null;
  var isHeaderCartCountHoldActive = false;
  var isApplyingHeaderCartCount = false;
  var headerCartCountHoldTimer = null;

  function readHeaderCartCount() {
    var countNodes = Array.prototype.slice.call(document.querySelectorAll('#cartCountContainer #cartCount, #cartCountContainer span'));
    var counts = countNodes
      .map(function (countNode) { return parseInt(countNode.textContent, 10); })
      .filter(function (count) { return Number.isFinite(count); });

    return counts.length ? Math.max.apply(Math, counts) : 0;
  }

  function setHeaderCartCount(itemCount) {
    var count = Number(itemCount) || 0;
    var containers = Array.prototype.slice.call(document.querySelectorAll('#cartCountContainer'));
    var toggles = Array.prototype.slice.call(document.querySelectorAll('.cart__toggle'));

    isApplyingHeaderCartCount = true;

    containers.forEach(function (container) {
      var countNode = container.querySelector('#cartCount, span');
      if (!countNode) {
        countNode = document.createElement('span');
        countNode.setAttribute('aria-hidden', 'true');
        countNode.id = 'cartCount';
        container.appendChild(countNode);
      }
      countNode.textContent = count;
    });

    toggles.forEach(function (toggle) {
      toggle.classList.toggle('cart__toggle--has-items', count > 0);
    });

    window.setTimeout(function () {
      isApplyingHeaderCartCount = false;
    }, 0);
  }

  function commitHeaderCartCount(itemCount) {
    confirmedHeaderCartCount = Number(itemCount) || 0;
    isHeaderCartCountHoldActive = false;
    heldHeaderCartCount = null;
    if (headerCartCountHoldTimer) {
      window.clearTimeout(headerCartCountHoldTimer);
      headerCartCountHoldTimer = null;
    }
    setHeaderCartCount(confirmedHeaderCartCount);
  }

  function holdHeaderCartCount(optimisticCount) {
    if (confirmedHeaderCartCount === null) {
      confirmedHeaderCartCount = readHeaderCartCount();
    }

    heldHeaderCartCount = typeof optimisticCount === 'number' ? optimisticCount : confirmedHeaderCartCount;
    isHeaderCartCountHoldActive = true;
    setHeaderCartCount(heldHeaderCartCount);

    if (headerCartCountHoldTimer) {
      window.clearTimeout(headerCartCountHoldTimer);
    }

    headerCartCountHoldTimer = window.setTimeout(function () {
      isHeaderCartCountHoldActive = false;
      heldHeaderCartCount = null;
      headerCartCountHoldTimer = null;
    }, 3500);
  }

  function observeHeaderCartCount() {
    var target = document.body;
    if (!target || window.pkHeaderCartCountObserver) return;

    window.pkHeaderCartCountObserver = new MutationObserver(function (mutations) {
      if (!isHeaderCartCountHoldActive || isApplyingHeaderCartCount) return;

      var changedCartCount = mutations.some(function (mutation) {
        var element = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return element && element.closest && element.closest('#cartCountContainer');
      });

      if (changedCartCount) {
        setHeaderCartCount(heldHeaderCartCount);
      }
    });

    window.pkHeaderCartCountObserver.observe(target, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function syncHeaderCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        commitHeaderCartCount(cart.item_count);
        return cart;
      });
  }

  function scheduleHeaderCartCountSync() {
    if (!isHeaderCartCountHoldActive) {
      holdHeaderCartCount();
    }

    [900, 1800, 3000].forEach(function (delay) {
      window.setTimeout(syncHeaderCartCount, delay);
    });
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function' && !window.pkHeaderCartCountFetchPatched) {
    window.pkHeaderCartCountFetchPatched = true;
    window.fetch = function () {
      var requestUrl = arguments[0];
      var requestPath = typeof requestUrl === 'string' ? requestUrl : (requestUrl && requestUrl.url) || '';
      var isCartMutation = requestPath.indexOf('/cart/add') !== -1 || requestPath.indexOf('/cart/change') !== -1 || requestPath.indexOf('/cart/update') !== -1 || requestPath.indexOf('/cart/clear') !== -1;

      if (isCartMutation) {
        if (confirmedHeaderCartCount === null) {
          confirmedHeaderCartCount = readHeaderCartCount();
        }

        if (!isHeaderCartCountHoldActive) {
          holdHeaderCartCount();
        }
      }

      var fetchResult = originalFetch.apply(this, arguments);

      if (isCartMutation) {
        fetchResult.then(scheduleHeaderCartCountSync).catch(function () {});
      }

      return fetchResult;
    };
  }

  window.pkSyncHeaderCartCount = syncHeaderCartCount;
  window.pkOptimisticHeaderCartCountAdd = function (quantity) {
    var addQuantity = Number(quantity) || 1;

    if (confirmedHeaderCartCount === null) {
      confirmedHeaderCartCount = readHeaderCartCount();
    }

    holdHeaderCartCount(confirmedHeaderCartCount + addQuantity);
  };

  document.addEventListener('theme:cart:added', scheduleHeaderCartCountSync);
  document.addEventListener('theme:cart:change', scheduleHeaderCartCountSync);
  document.addEventListener('cart:refresh', scheduleHeaderCartCountSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeHeaderCartCount();
      syncHeaderCartCount();
    }, { once: true });
  } else {
    observeHeaderCartCount();
    syncHeaderCartCount();
  }
})();

document.addEventListener("DOMContentLoaded", (event) => {
  let header = document.querySelector('.yas_header');
  if (!header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop > 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }
  if (header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop <= 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }

  let swiperReview = document.querySelector('.review_global .mySwiper_review');
  if(swiperReview != null){
    var swiper = new Swiper('.review_global .mySwiper_review', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.review_global .swiper-button-next',
        prevEl: '.review_global .swiper-button-prev',
      },
    });
  }


  const filterBlock = document.querySelector('.filter_btnside .mc-link');

  if (filterBlock) {
    const links = filterBlock.querySelectorAll('a');
  
    links.forEach(link => {
      link.addEventListener('click', function (e) {
         if (link.target === '_blank') return;
         
          e.preventDefault();

          document.documentElement.classList.remove('is-loaded');
          window.location.href = link.href;
      });
    });
  }

  
  let swiperProduct = document.querySelector('.mySwiper_product_img');
  if(swiperProduct != null){
    function updateProductGalleryVideoOverlay(video) {
      var videoContainer = video.closest('.product-single__video');

      if (videoContainer) {
        videoContainer.classList.toggle('is-video-playing', !video.paused && !video.ended);
      }
    }

    function prepareProductGalleryVideo(video) {
      var sources = video.querySelectorAll('source[data-gallery-src]');
      if (!sources.length) return;
      sources.forEach(function(source) {
        source.setAttribute('src', source.getAttribute('data-gallery-src'));
        source.removeAttribute('data-gallery-src');
      });
      video.load();
    }

    // Native video controls and the overlay both load media on user intent only.
    ['pointerdown', 'keydown'].forEach(function(eventName) {
      swiperProduct.addEventListener(eventName, function(event) {
        if (event.target.matches('video')) prepareProductGalleryVideo(event.target);
      });
    });

    swiperProduct.addEventListener('click', function(event) {
      var playButton = event.target.closest('.product-gallery-video-play');

      if (!playButton) return;

      var videoContainer = playButton.closest('.product-single__video');
      var video = videoContainer ? videoContainer.querySelector('video') : null;

      if (!video) return;

      event.preventDefault();
      event.stopPropagation();

      prepareProductGalleryVideo(video);
      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    });

    swiperProduct.addEventListener('play', function(event) {
      if (event.target.matches('video')) {
        updateProductGalleryVideoOverlay(event.target);
      }
    }, true);

    swiperProduct.addEventListener('pause', function(event) {
      if (event.target.matches('video')) {
        updateProductGalleryVideoOverlay(event.target);
      }
    }, true);

    swiperProduct.addEventListener('ended', function(event) {
      if (event.target.matches('video')) {
        updateProductGalleryVideoOverlay(event.target);
      }
    }, true);

    function resetInactiveProductGalleryMedia(swiperInstance) {
      var activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      swiperProduct.querySelectorAll('.swiper-slide').forEach(function(slide) {
        if (slide === activeSlide) return;

        slide.querySelectorAll('video').forEach(function(video) {
          video.pause();
        });

        slide.querySelectorAll('iframe').forEach(function(iframe) {
          var src = iframe.getAttribute('src') || '';
          var message = null;

          if (src.indexOf('youtube.com') > -1 || src.indexOf('youtube-nocookie.com') > -1) {
            message = JSON.stringify({
              event: 'command',
              func: 'pauseVideo',
              args: []
            });
          } else if (src.indexOf('vimeo.com') > -1) {
            message = JSON.stringify({
              method: 'pause'
            });
          }

          if (message && iframe.contentWindow) {
            iframe.contentWindow.postMessage(message, '*');
          }
        });
      });
    }

    var swiper = new Swiper(".mySwiper_product_img", {
      slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        on: {
          init: resetInactiveProductGalleryMedia,
          slideChangeTransitionStart: resetInactiveProductGalleryMedia
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".mySwiper_product_img .swiper-button-next",
          prevEl: ".mySwiper_product_img .swiper-button-prev",
        },
        breakpoints: {
          // when window width is <= 576px (mobile)
          469: {
            slidesPerView: 1.5,
            spaceBetween: 10
          },
          659: {
            slidesPerView: 2.5,
            spaceBetween: 10
          },
          // when window width is <= 992px (tablet)
          992: {
            slidesPerView: 3.5,
            spaceBetween: 10
          },
          // when window width is > 992px (desktop)
          1200: {
            slidesPerView: 3.5,
            spaceBetween: 10
          }
        }
      });
  }


  let midSwipermob = document.querySelector('.midSwipermob');
  if(midSwipermob != null){
      var swiper = new Swiper(".firstwipemob", {
        freeMode: true,
        loop: true,
        //rtl: true,  // Enable right-to-left mode
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        slidesPerView: 2.5,
        spaceBetween: 10,
        speed: 2500,
        pagination: {
          el: ".firstwipemob .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });
      var swiper = new Swiper(".midSwipermob", {
       freeMode: true,
        loop: true,
        autoplay: {
        delay: 0,
        disableOnInteraction: false,
        },
        slidesPerView: 2.5,
        spaceBetween: 10,
        speed: 3000,
        pagination: {
          el: ".midSwipermob .swiper-pagination",
          clickable: true,
        },
      });
  }
  let firstwipe = document.querySelector('.firstwipe');
  if(firstwipe != null){
    function initializeSwiper(selector, speed, direction, revers) {
      new Swiper(selector, {
          direction: direction,
          freeMode: true,
          a11y: false,
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 15,
          autoHeight: true,
          grabCursor: true,
          loopAdditionalSlides: 2,
          loopAddBlankSlides: true,
          autoplay: {
             delay: 0,
             disableOnInteraction: false,
             reverseDirection: revers,
          },
          breakpoints: {
              768: {
                  spaceBetween: 15,
              },
              1024: {
                  spaceBetween: 15,
              },
          },
          speed: speed,
  
      });
  }

  // Initialize Swipers
  initializeSwiper(".firstwipe", 4000, "vertical", false);
  initializeSwiper(".midSwiper", 3000, "vertical", true);
  initializeSwiper(".rightswipe", 5000, "vertical", false);
  }

  let slider_section_yas = document.querySelector('.slider_section-yas');
    if(slider_section_yas != null){
      var swiper = new Swiper(".slider_section-yas .swiper_slider", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: false,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
        },
      });
  }

  let mobile_slider_section_yas = document.querySelector('.mobile_slider_section-yas');
    if(mobile_slider_section_yas != null){
      var swiper = new Swiper(".mobile_slider_section-yas .mobile_slider", {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: false,
        
      });
  }

  
  let badges_mobile = document.querySelector('.badges_mobile');
    if(badges_mobile != null){
    var swiper = new Swiper(".badges_mobile", {
       freeMode: true,
        loop: true,
        autoplay: {
        delay: 0,
        freeMode: true,
        disableOnInteraction: false,
        },
        slidesPerView: 2,
        spaceBetween: 0,
        speed: 5000,
        pagination: false,
    });
  }


  let secrch_banner_yas = document.querySelector('#secrch_banner_yas');

  if(secrch_banner_yas != null){
    const searchInput = document.getElementById('secrch_banner_yas');
    const originalPlaceholder = searchInput.getAttribute('placeholder');
    const collectionList = document.querySelector('.search_banner .collection-list');
    const searchForm = document.querySelector('.banner_search_form');
    
    function hideCollectionList() {
      collectionList.style.display = 'none';
    }
    
    function showCollectionList() {
      collectionList.style.display = 'block';
    }
    
    function resetInputToPlaceholder() {
      searchInput.value = '';
      searchInput.setAttribute('placeholder', originalPlaceholder);
    }
    
    searchInput.addEventListener('click', function(event) {
      event.stopPropagation();
      showCollectionList();
    });
    
    document.body.addEventListener('click', function(event) {
      if (
        !event.target.closest('.search-form') &&
        !event.target.closest('.collection-list') 
      ) {
   
        hideCollectionList();
       // resetInputToPlaceholder();
      }
    });
    
    searchInput.addEventListener('input', function() {
      const query = searchInput.value.toLowerCase();
      const listItems = collectionList.querySelectorAll('li');
    
      listItems.forEach(function(item) {
        const collectionTitle = item.textContent.toLowerCase();
        if (collectionTitle.includes(query)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
    
    searchForm.addEventListener('submit', function(event) {
      event.preventDefault();
      var firstVisibleLi = Array.from(
        document.querySelectorAll('.search_banner .collection-list li')
      ).find(el => getComputedStyle(el).display !== 'none');
      
      if (firstVisibleLi) {
        var link = firstVisibleLi.querySelector('a');
        if (link) {
          link.click();
        }
      }
    });
  }


  if (!document.getElementById('calendly-widget-script')) {
          // Load Calendly stylesheet
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://assets.calendly.com/assets/external/widget.css';
          document.head.appendChild(link);
    
          // Load Calendly script
          var script = document.createElement('script');
          script.src = 'https://assets.calendly.com/assets/external/widget.js';
          script.id = 'calendly-widget-script';
          script.async = true;
          document.body.appendChild(script);
  }

  
});

(function () {
  function getAcceptanceCheckboxes(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-cart-acceptance-checkbox]'));
  }

  function allAccepted(form) {
    var checkboxes = getAcceptanceCheckboxes(form);
    return checkboxes.length && checkboxes.every(function (checkbox) {
      return checkbox.checked;
    });
  }

  function firstUnchecked(form) {
    return getAcceptanceCheckboxes(form).find(function (checkbox) {
      return !checkbox.checked;
    });
  }

  function setAcceptanceState(form, showError) {
    var row = form.querySelector('[data-cart-acceptance-row]');
    var errorMessage = form.querySelector('[data-terms-error-message]');
    var accepted = allAccepted(form);

    if (row) {
      row.classList.toggle('is-acceptance-pulsing', !accepted);
      row.classList.toggle('is-acceptance-error', Boolean(showError && !accepted));
    }

    if (errorMessage) {
      if (showError && !accepted) {
        errorMessage.textContent = (window.theme && window.theme.strings && window.theme.strings.cart_acceptance_error) || 'Please confirm all required checkout terms.';
        errorMessage.classList.add('is-expanded');
      } else if (accepted) {
        errorMessage.textContent = '';
        errorMessage.classList.remove('is-expanded');
      }
    }
  }

  function bindCartAcceptanceForm(form) {
    if (!form || form.dataset.pkCartAcceptanceBound === 'true') return;
    if (!getAcceptanceCheckboxes(form).length) return;

    form.dataset.pkCartAcceptanceBound = 'true';

    getAcceptanceCheckboxes(form).forEach(function (checkbox) {
      checkbox.checked = false;
      checkbox.addEventListener('change', function () {
        setAcceptanceState(form, false);
      });
    });

    setAcceptanceState(form, false);
  }

  function bindCartAcceptanceForms() {
    document.querySelectorAll('form[data-cart-form]').forEach(bindCartAcceptanceForm);
  }

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('button[name="checkout"]');
    if (!checkoutButton) return;

    var form = checkoutButton.closest('form[data-cart-form]');
    if (!form || allAccepted(form)) return;

    var checkbox = firstUnchecked(form);
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    setAcceptanceState(form, true);
    if (checkbox) checkbox.focus();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[data-cart-form]')) return;

    var submitter = event.submitter;
    var isCheckoutSubmit = !submitter || submitter.name === 'checkout';
    if (!isCheckoutSubmit || allAccepted(form)) return;

    var checkbox = firstUnchecked(form);
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    setAcceptanceState(form, true);
    if (checkbox) checkbox.focus();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartAcceptanceForms);
  } else {
    bindCartAcceptanceForms();
  }

  document.addEventListener('theme:cart:loaded', bindCartAcceptanceForms);
  document.addEventListener('theme:cart:change', bindCartAcceptanceForms);
})();
